import { createIntl, IntlShape, OptionalIntlConfig } from '@formatjs/intl';
import { defaultLocale } from './constants';

let intl = createIntl(buildIntlConfig());

export function buildIntlConfig(locale = defaultLocale): OptionalIntlConfig {
  return {
    locale,
    messages: {}
  };
}

export function setIntl(newIntl: IntlShape<string>) {
    intl = newIntl;
}

export { intl };